export function formatGpuName(name?: string) {
  if (!name) return "";
  return name
    .replace(/NVIDIA/gi, "")
    .split("(")[0]
    .trim();
}

const RTX_PRO_6000_ALIASES = new Set([
  "rtxpro6000",
  "rtxproserver6000",
  "rtxserver6000pro",
  "rtx6000pro",
]);

export function getCanonicalGpuName(name?: string) {
  const formattedName = formatGpuName(name);
  const compactName = formattedName.replace(/\s+/g, "").toLowerCase();

  if (RTX_PRO_6000_ALIASES.has(compactName)) {
    return "RTX PRO 6000";
  }

  return formattedName;
}

export function gpuNamesMatch(name?: string, selectedName?: string) {
  if (!name || !selectedName) return false;
  return (
    getCanonicalGpuName(name).toLowerCase() ===
    getCanonicalGpuName(selectedName).toLowerCase()
  );
}
